module.exports = __webpack_public_path__ + "static/media/01-brille.69e0d0bc.jpg";